import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useToaster } from "@hellocontento/maillard";

import {
  SecondaryHeader,
  SecondaryHeaderContainer
} from "../navigation/styles";
import Tooltip from "components/common/Tooltip";
import OldTabMenu from "../navigation/OldTabMenu";
import { generatePdf } from "utils/pdfGeneration";
import IconButton from "components/common/IconButton";
import { trackAnalyticsEvent } from "state/actions/AnalyticsActions";
import PeriodSelect, { periodMenuItems } from "./widgets/PeriodSelect";

const menuOptions = [
  {
    label: "Overview",
    value: "overview"
  },
  {
    label: "Posts",
    value: "posts"
  }
];

function OldAnalyticsMenu({ onTabClick, onPeriodSelect, period, isLoading }) {
  const addToast = useToaster();
  const dispatch = useDispatch();
  const location = useLocation();

  const pdfDownload = () => {
    try {
      generatePdf("analytics-report", "analytics-report-page");

      dispatch(
        trackAnalyticsEvent("Analytics Downloaded", {
          type:
            location.pathname.match(
              /^.*\/accounts\/[^/]*\/analytics\/([^/?]*).*$/
            )?.[1] ?? "",
          timeframe: periodMenuItems.find(item => item.value === period).label
        })
      );
    } catch (_) {
      addToast(
        "There was an error downloading the report. Please try again later or contact support.",
        "error"
      );
    }
  };

  return (
    <SecondaryHeader>
      <SecondaryHeaderContainer>
        <OldTabMenu options={menuOptions} onClick={onTabClick} />
        <div className="right-menu">
          <Tooltip title="Download report" placement="bottom">
            <IconButton
              size={"sm"}
              iconSize={20}
              icon="icon-download"
              disabled={isLoading}
              onClick={pdfDownload}
              variant={"secondary"}
            />
          </Tooltip>
          <PeriodSelect onSelect={onPeriodSelect} selected={period} />
        </div>
      </SecondaryHeaderContainer>
    </SecondaryHeader>
  );
}

export default OldAnalyticsMenu;
